var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 21H4.9335C4.37344 21 4.09342 21 3.87951 20.891C3.69134 20.7951 3.53836 20.6422 3.44249 20.454C3.3335 20.2401 3.3335 19.9601 3.3335 19.4V3M20.3335 8L16.4146 12.1827C16.2661 12.3412 16.1918 12.4204 16.1023 12.4614C16.0232 12.4976 15.9361 12.5125 15.8495 12.5047C15.7513 12.4958 15.655 12.4458 15.4622 12.3457L12.2048 10.6543C12.012 10.5542 11.9156 10.5042 11.8175 10.4953C11.7309 10.4875 11.6438 10.5024 11.5647 10.5386C11.4751 10.5796 11.4009 10.6588 11.2524 10.8173L7.3335 15",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartIcon);
export default __webpack_public_path__ + "static/media/lineChartIcon.759ce1dc4023191bc165c8c296bc9a1c.svg";
export { ForwardRef as ReactComponent };